<div class="flex items-center bg-blue-400 text-white text-sm px-4 py-3" role="alert">
    <mat-icon class="fill-current w-4 h-4 mr-2">info</mat-icon>
    <p>Entité en lecture seule</p>
</div>

<br>

<ag-grid-angular
    style="width: 100%; height: 100%;"
    [columnDefs]="columns"
    [autoSizeStrategy]="autoSizeStrategy"
    [loading]="true"
    [localeText]="localeText"
    (gridReady)="onGridReady($event)"
/>